module.exports = __webpack_public_path__ + "static/roche-logo-105b7bb1a55a883dbf59da30a4ba4b70.png";